import { HttpWrapper } from '@/shared/services/rest.service';
import * as endpoints from './endpoints';

export default {
    getAllSnuTasks() {
        return HttpWrapper.get(`${endpoints.SNUTASK}`);
    },
    getSnuTaskDataByTemplateId(templateId) {
        return HttpWrapper.get(`${endpoints.SNUTASK}/data/${templateId}`);
    },
    getSnuTaskDataByMilestoneId(milestoneId) {
        return HttpWrapper.get(`${endpoints.SNUTASK}/data/milestone/${milestoneId}`);
    },
    getSnuTasks(templateId, showDisabled) {
        return HttpWrapper.get(`${endpoints.SNUTASK}/ordered/${templateId}/${showDisabled}`);
    },
    addSnuTasks(snuTasks) {
        return HttpWrapper.post(`${endpoints.SNUTASK}`, snuTasks);
    },
    updateSnuTask(snuTask) {
        return HttpWrapper.put(`${endpoints.SNUTASK}`, snuTask);
    },
    reorderSnuTasks(snuTasks) {
        return HttpWrapper.put(`${endpoints.SNUTASK}/reorder`, snuTasks);
    },
    syncSnuTasks(templateTypeId) {
        return HttpWrapper.put(`${endpoints.SNUTASK}/syncSnuTasks/${templateTypeId}`);
    },
    disableSnuTask(snuTaskId) {
        return HttpWrapper.put(`${endpoints.SNUTASK}/${snuTaskId}/disable`);
    },
    enableSnuTask(snuTaskId) {
        return HttpWrapper.put(`${endpoints.SNUTASK}/${snuTaskId}/enable`);
    },
    deleteSnuTask(snuTaskId) {
        return HttpWrapper.delete(`${endpoints.SNUTASK}/${snuTaskId}`);
    }
}